import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getToken } from '../../utils/sessionManagement'

// handle the public routes
const PublicRoutes = () => {
  return <Outlet />
}

export default PublicRoutes
